import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConventionExhibitorRequest } from '@fg-types/convention-exhibitor';
import { ListItem } from '@fg-shared/layout/flat-list/list-item.component';
import { ExhibitorHelpers } from '@fg-shared/helpers/exhibitor-helpers';

@Component({
  selector: 'exhibitor-request-tile',
  templateUrl: './exhibitor-request-tile.component.html',
  styleUrls: ['./exhibitor-request-tile.component.scss']
})
export class ExhibitorRequestTileComponent implements ListItem<ConventionExhibitorRequest> {
  @Input() data: ConventionExhibitorRequest;
  @Input() active?: boolean;
  @Output() onClick = new EventEmitter<void>();
  @Input() hoverActive: boolean;
  // Calculated values
  get imageUrl() {
    return ExhibitorHelpers.getImage(this.data.exhibitor);
  }
}
